import { render, staticRenderFns } from "./TabSide.vue?vue&type=template&id=affcd4b0&scoped=true&"
import script from "./TabSide.vue?vue&type=script&lang=js&"
export * from "./TabSide.vue?vue&type=script&lang=js&"
import style0 from "./TabSide.vue?vue&type=style&index=0&id=affcd4b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affcd4b0",
  null
  
)

export default component.exports